(($) => {
    /***************************** Variables ****************************/
    const header_dropdown_toggle = $('.header_main_item--clickable');
    const relatedItems = $('.main_view_related__item');
    const headerItemAlternativeDropdownTitle = $('.header_item_alternative_dropdown_title');
    const backgroundOverlay = $('.header_overlay');
    const headerMenuGeneralDropdownToggle = $('.header_general_dropdown_title');
    const header = $('.header');
    const top_bar = $(".header .topbar");
    const main_bar = $('.header .mainbar');
    const mega_menu = $('.header_main_dropdown');
    let mouseOverTimer;

    /***************************** Functions ****************************/
    function headerMenuToggle(element){
        // headerMenusClose('mega_menu');
        backgroundOverlay.addClass('active');
        mega_menu.addClass('active');
        element.addClass('active');
    }

    function closeMenu(){
        $('.dropdown_item').removeClass('active');
        backgroundOverlay.removeClass('active');
        $('.header_dropdown').removeClass('active');
        $(header_dropdown_toggle).removeClass('active');
        $('.header .header_banner').removeClass('active');
    }

    header_dropdown_toggle.on("mouseenter", function(){
        let dropdown_version = $(this).data('version');
        $(header_dropdown_toggle).removeClass('active');
        $(this).addClass('active');
        $('.dropdown_item').removeClass('active');
        $('.dropdown_item--'+dropdown_version).addClass('active');
        backgroundOverlay.addClass('active');
        $('.header_dropdown').addClass('active');
        $('.header .header_banner').addClass('active');
    });
    
    top_bar.on("mouseenter", function(){
        closeMenu();
    });

    $('.logo--desktop, .header_main_item--unclickable, .input_and_logo, .menu_cta_option').on("mouseenter", function(){
        closeMenu();
    });

    header.on("mouseleave", function(){
        closeMenu();
    });

    $('.topbar_dropdown_toggle').on("mouseenter", function( event ){
        $(this).addClass('active');
        backgroundOverlay.addClass('active');
        event.stopPropagation();
        $('.b__item__dropdown').addClass('active');
    });

    $('.topbar_dropdown_toggle').on("mouseleave", function(){
        $(this).removeClass('active');
        backgroundOverlay.removeClass('active');
        $('.b__item__dropdown').removeClass('active');
    });

    $('.side_a__item_single').on("mouseover", function(){
        console.log("bean");
        let single_item_to_swap = $(this).data('single');
        let parent_dropdowns_version = $(this).parent().parent().parent().data('dropdown-version');
        $('.dropdown_item--' + parent_dropdowns_version).find('.side_b__content').removeClass('active');
        $('.side_b__content--' + single_item_to_swap).addClass('active');
    });
    
    $(window).on('resize', function(){
        if($(window).width() < 1300){
            closeMenu();    
        }
    });

    // scrolling behaviour, filter row stuff relates to filter_row JS, filters stuck to top
    let prev_scroll_pos = $(window).scrollTop();
    let is_scrolled_up = false;
    $(window).scroll(function(){
        var current_scroll_pos = $(window).scrollTop();
        let mainbar_height = $('header .mainbar').height();

        if ('.post-type-archive-catalogue') {
            return;
        }

        if(prev_scroll_pos > current_scroll_pos){
            $(main_bar).css("margin-top", "0");
            main_bar.data('scrolled', false);
            is_scrolled_up = false;
        }else if (current_scroll_pos > prev_scroll_pos + (mainbar_height / 2)){
            $(main_bar).css("margin-top", '-' + mainbar_height + 'px');
            main_bar.data('scrolled', true);
            is_scrolled_up = true;
        }
        prev_scroll_pos = current_scroll_pos;
    });

    $(window).on('resize', function(){
        $(main_bar).css("margin-top", "0");
        main_bar.data('scrolled', false);
        is_scrolled_up = false;
    });

    // filter row & posts skip to section elements stick to top behaviour
    /**
     * Adjusts the position of an element to scroll with the header.
     *
     * @param {string} element_div - The selector for the element that should scroll with the header.
     * @param {string} next_div - The selector for the element immediately following the scrolling element.
     * @param {boolean} alter - A flag indicating whether to alter the margin of the next element.
     * @param {boolean} [checkWidth=true] - A flag indicating whether to check the window width before applying the scroll behavior.
     */
    function element_scrolls_with_header(element_div, next_div, alter, checkWidth = true) {
        if ($(element_div)[0]) {
            const element = $(element_div);
            const element_after = $(next_div);
    
            function updateElementPosition() {
                let element_top = element_after.offset().top;
                let filter_row_height = element.outerHeight();
                let viewport_top = $(window).scrollTop();
                let topbar_height = top_bar.outerHeight();
                let mainbar_height = main_bar.outerHeight();
    
                if (viewport_top > element_top) {
                    element.addClass('active');
                    if (alter) {
                        element_after.css('margin-top', filter_row_height);
                    }
                } else {
                    element.removeClass('active');
                    if (alter) {
                        element_after.css('margin-top', 'unset');
                    }
                }
    
                if (element.hasClass('active')) {
                    element.css('top', is_scrolled_up ? topbar_height : topbar_height + mainbar_height);
                }
            }
    
            function main_behaviour() {
                if (!checkWidth || $(window).width() > 1299) {
                    updateElementPosition();
                }
            }
    
            main_behaviour();
    
            $(window).on('scroll', main_behaviour);
            $(window).on('resize', function() {
                setTimeout(main_behaviour, 200);
            });
        }
    }
    
    element_scrolls_with_header('.filter_row', '.products-posts-content', true);
    element_scrolls_with_header('.pageNavigationMain', '.article-main-col', false, false);
    
    /***************************** Event Listeners ****************************/
   
    $('.header .topbar').click(function (evt) {
        evt.stopPropagation();
    });

    $('.header .mainbar').click(function (evt) {
        evt.stopPropagation();
    });

})(jQuery);